import DeviceLogContext from "../context/AdminDashboard/DeviceLogContext";
import DeviceLog from "../pages/AdminDashboard/DeviceLog";

import DeviceDetailContext from "../context/AdminDashboard/DeviceDetailContext";
import DeviceDetails from "../pages/AdminDashboard/DeviceDetails";
import ServiceDetailContext from "../context/AdminDashboard/ServiceDetailContext";
import ServiceDetail from "../pages/AdminDashboard/ServiceDetail";
import ModelDetailContext from "../context/AdminDashboard/ModelsDetailContext";
import ModelsDetail from "../pages/AdminDashboard/ModelsDetail";
import ModelAddContext from "../context/AdminDashboard/ModelsAddEditContext";
import ModelsAdd from "../pages/AdminDashboard/ModelsAdd";
import ModelEdit from "../pages/AdminDashboard/ModelEdit";
import React from "react";
import {Outlet} from "react-router-dom";
import {DevicesContextProvider} from "../pages/devices/DevicesContext";
import DevicesScreen from "../pages/devices/DevicesScreen";
import {ModelsContextProvider} from "../pages/models/ModelsContext";
import ModelsScreen from "../pages/models/ModelsScreen";
import {ServiceProvider} from "../pages/services/ServiceContext";
import ServiceScreen from "../pages/services/ServiceScreen";

const deviceRoutes = {
    path: "device",
    element: <Outlet/>,
    children: [
        {
            path: "list/log",
            element: (
                <DeviceLogContext>
                    <DeviceLog/>
                </DeviceLogContext>
            )
        },
        {
            path: "list",
            element: (
                <DevicesContextProvider>
                    <DevicesScreen/>

                </DevicesContextProvider>
            )
        },
        {
            path: "service",
            element: (
                <ServiceProvider>
                    <ServiceScreen/>
                </ServiceProvider>
            )
        },
        {
            path: "models",
            element: (
                <ModelsContextProvider>
                    <ModelsScreen/>
                </ModelsContextProvider>
            )
        },
        {
            path: "list/details",
            element: (
                <DeviceDetailContext>
                    <DeviceDetails/>
                </DeviceDetailContext>

            )
        },
        {
            path: "Service/details",
            element: (
                <ServiceDetailContext>
                    <ServiceDetail/>
                </ServiceDetailContext>
            )
        },
        {
            path: "models/details",
            element: (
                <ModelDetailContext>
                    <ModelsDetail/>
                </ModelDetailContext>
            )
        },
        {
            path: "models/add",
            element: (
                <ModelAddContext>
                    <ModelsAdd/>
                </ModelAddContext>
            )
        },
        {
            path: "models/edit",
            element: (
                <ModelAddContext>
                    <ModelEdit/>
                </ModelAddContext>
            )
        },
    ]
}

export default deviceRoutes;